module.exports = __webpack_public_path__ + "img/UTFLIG-2.b4eeb722.jpg";